import * as _ from 'lodash'
import globalRelay from './globalRelay';
import * as globalActions from './actions';
import enums from './enum';
import * as contractorActions from './contractorActions';
import * as employeeActions from './employeeActions';
import * as fileActions from './fileActions';
import * as vendorActions from './vendorActions';
import serviceGateway from './serviceGateway';
import store, { DomainEntityType, getDomainEntities } from './store';
import componentServices from './componentServices';
import jobModel from './models/jobModel';
import contactModel from './models/contactModel';

const reportHost = globalRelay.environment === 'Production' ? 'relayreports.legacykitchens.com' : 'stagerelayreports.legacykitchens.com';

const defaultShaper = data => {
	return data;
};

export function changeAccountingSummaryShaper(data, job, summaries) {
	const jobCost = summaries[0].jobCost;

	data.jobCosts[0].settings.push({ name: 'reporting-primaryAccountingId', group: 0, value: jobCost.accountingId });

	return data;
}

export function templateShaper(data) {
	const { name, phoneNumbers, type } = data.builder
	if (type === 4) {
		if (data.addresses.length === 1) {
			data.addresses[0].type = 20 //31
		}
		const contactInfo = {
			firstName: name,
			lastName: "Model",
			phoneNumbers: phoneNumbers,
			priority: 0,
			preferredContactMethod: _.find(phoneNumbers, i => i.type === enums.phoneNumberTypes.Work) ? enums.contactMethods.Office_Phone : enums.contactMethods.Unknown
		}

		data.clientContacts.push(contactModel(contactInfo))
	}
	return data;
}

const fillJobCostData = async (summary) => {
	let model = store().get('model');
	const jobCost = summary.jobCost;
	const contractorsToFetch: any[] = [];
	const vendorsToFetch: any[] = [];
	const employeesToFetch: any[] = [];
	let fetchPromise;
	const fetches: any[] = [];

	_.forEach(['createdById', 'lastModifiedById'], k => {
		const key = (jobCost.currentChangeOrder || jobCost)[k];
		if (key && employeesToFetch.indexOf(key) === -1 && !model.get('employees').find(e => e.user.key === key)) {
			fetches.push(employeeActions.fetchEmployee({ userKey: key }));
		}
	});

	if (jobCost.proposal && jobCost.proposal.accountManagerKey && employeesToFetch.indexOf(jobCost.proposal.accountManagerKey) === -1 && !model.getIn(['employees', jobCost.proposal.accountManagerKey])) {
		employeesToFetch.push(jobCost.proposal.accountManagerKey);
		fetches.push(employeeActions.fetchEmployee({ key: jobCost.proposal.accountManagerKey }));
	}

	_.forEach(jobCost.workAreas, workArea => {
		if (workArea.vendorKey && vendorsToFetch.indexOf(workArea.vendorKey) === -1 && !model.getIn(['vendors', workArea.vendorKey])) {
			vendorsToFetch.push(workArea.vendorKey);
		}
	});

	_.forEach(jobCost.lineItems, item => {
		if (item.contractorKey && contractorsToFetch.indexOf(item.contractorKey) === -1 && !model.getIn(['contractors', item.contractorKey])) {
			contractorsToFetch.push(item.contractorKey);
		}
		if (item.vendorKey && vendorsToFetch.indexOf(item.vendorKey) === -1 && !model.getIn(['vendors', item.vendorKey])) {
			vendorsToFetch.push(item.vendorKey);
		}
	});

	_.forEach(contractorsToFetch, key => {
		fetches.push(contractorActions.fetchContractor({ key }));
	});

	_.forEach(vendorsToFetch, key => {
		fetches.push(vendorActions.fetchVendor({ key }));
	});

	//console.log({ contractorsToFetch, vendorsToFetch});

	if (fetches.length) {
		fetchPromise = Promise.all(fetches);
	}
	else {
		fetchPromise = Promise.resolve();
	}

	await fetchPromise;
	const storeInstance = store();
	const glassTypes = getDomainEntities({ store: storeInstance, type: DomainEntityType.glassTypes });
	const doorSizes = getDomainEntities({ store: storeInstance, type: DomainEntityType.doorSizes });
	const subTradeTypes = getDomainEntities({ store: storeInstance, type: DomainEntityType.subTradeTypes });
	const jcDoc = jobCost.toDocument();
	const currentChangeOrder = jobCost.currentChangeOrder && _.find(jcDoc.changeOrders, { key: jobCost.currentChangeOrder.key });

	// be sure our model includes the items we just fetched
	model = storeInstance.get('model');

	// make a change order appear like a standard job cost and be sure to include parent items for diffing
	if (currentChangeOrder) {
		_.assign(jcDoc, currentChangeOrder);

		_.forEach(_.filter(jobCost.lineItems, { isChange: true }), item => {
			const itemDoc = _.find(jcDoc.lineItems, { key: item.key });

			itemDoc.isChange = true;
			itemDoc.isAddition = item.isAddition;
			itemDoc.isModification = item.isModification;
			itemDoc.isDeletion = item.isDeletion;

			if (item.parent) {
				itemDoc.parentKey = item.parent.key;
				jcDoc.lineItems.push(item.parent.toDocument());
			}
		});

		// rebuild all specifications so that reporting can display the full set with changes
		jcDoc.specifications = [];
		_.forEach(jobCost.proxiedContract.specifications, item => {
			const itemDoc = item.toDocument();

			itemDoc.isChange = item.isAddition || item.isModification || item.isDeletion;
			itemDoc.isAddition = item.isAddition;
			itemDoc.isModification = item.isModification;
			itemDoc.isDeletion = item.isDeletion;

			if (item.parent) {
				itemDoc.parentKey = item.parent.key;
				//jcDoc.specifications.push(item.parent.toDocument());
			}

			jcDoc.specifications.push(itemDoc);
		});
	}

	jcDoc.summary = summary.toJSON();
	jcDoc.changeOrders = undefined;

	_.forEach(jcDoc.lineItems, item => {
		const contractor = model.getIn(['contractors', item.contractorKey]);
		const vendor = model.getIn(['vendors', item.vendorKey]);

		item.contractor = contractor ? contractor.toDocument() : contractor;
		item.vendorName = vendor ? vendor.name : undefined;

		if (item.glassTypeKey) {
			item.glassType = _.find(glassTypes, { key: item.glassTypeKey });
		}

		jcDoc.summary = summary.toJSON();
		jcDoc.changeOrders = undefined;

		_.forEach(jcDoc.lineItems, item => {
			const contractor = model.getIn(['contractors', item.contractorKey]);
			const vendor = model.getIn(['vendors', item.vendorKey]);

			item.contractor = contractor ? contractor.toDocument() : contractor;
			item.vendorName = vendor ? vendor.name : undefined;

			if (item.glassTypeKey) {
				item.glassType = _.find(glassTypes, { key: item.glassTypeKey });
			}
			if (item.doorSizeKey) {
				item.doorSize = _.find(doorSizes, { key: item.doorSizeKey });
			}
			if (item.subTradeTypeKey) {
				item.subTradeType = _.find(subTradeTypes, { key: item.subTradeTypeKey });
			}
			if (item.workAreaKey) {
				item.workAreaName = _.find(jcDoc.workAreas, { key: item.workAreaKey }).name;
			}
		});

		// add specification file urls
		_.forEach(jcDoc.specifications, item => {
			const specFile = model.get('files').find(f => {
				return f.relatedTypeKey === item.key;
			});

			item.fileKey = specFile && specFile.key;
		});

		_.forEach(jcDoc.workAreas, workArea => {
			const vendor = model.getIn(['vendors', workArea.vendorKey]);

			workArea.vendorName = vendor ? vendor.name : undefined;
		});

		jcDoc.relayNumber = (currentChangeOrder && jobCost.currentChangeOrder.relayNumber) || jobCost.relayNumber;

		_.forEach(['createdById', 'lastModifiedById'], k => {
			const target = currentChangeOrder || jcDoc;
			const employee = model.get('employees').find(e => e.user.key === target[k]);
			jcDoc[k.replace('Id', '')] = employee && employee.toDocument();
			jcDoc[k] = undefined;
		});

		if (jobCost.proposal) {
			jcDoc.proposal = jobCost.proposal.toDocument();
			jcDoc.proposal.date = jcDoc.proposal.date && new Date(jcDoc.proposal.date);
			if (jcDoc.proposal.accountManagerKey) {
				jcDoc.proposal.accountManager = model.getIn(['employees', jcDoc.proposal.accountManagerKey]);
				jcDoc.proposal.accountManagerKey = undefined;
			}
		}
	});

	// add specification file urls
	_.forEach(jcDoc.specifications, item => {
		const specFile = model.get('files').find(f => {
			return f.relatedTypeKey === item.key;
		});

		item.fileKey = specFile && specFile.key;
	});

	_.forEach(jcDoc.workAreas, workArea => {
		const vendor = model.getIn(['vendors', workArea.vendorKey]);

		workArea.vendorName = vendor ? vendor.name : undefined;
	});

	jcDoc.relayNumber = (currentChangeOrder && jobCost.currentChangeOrder.relayNumber) || jobCost.relayNumber;

	_.forEach(['createdById', 'lastModifiedById'], k => {
		const target = currentChangeOrder || jcDoc;
		const employee = model.get('employees').find(e => e.user.key === target[k]);
		jcDoc[k.replace('Id', '')] = employee && employee.toDocument();
		jcDoc[k] = undefined;
	});

	if (jobCost.proposal) {
		jcDoc.proposal = jobCost.proposal.toDocument();
		jcDoc.proposal.date = jcDoc.proposal.date && new Date(jcDoc.proposal.date);
		if (jcDoc.proposal.accountManagerKey) {
			jcDoc.proposal.accountManager = model.getIn(['employees', jcDoc.proposal.accountManagerKey]);
			jcDoc.proposal.accountManagerKey = undefined;
		}
	}

	return jcDoc;
};

export const createReportingJobForContractorTemplate = async (contractorKey) => {

	let model = store().get('model');

	if (contractorKey && !model.getIn(['contractors', contractorKey])) {
		await contractorActions.fetchContractor({ key: contractorKey });
		model = store().get('model');
	}

	const builder = model.getIn(['contractors', contractorKey]);
	const currentModule = componentServices.routeParams.moduleKey;
	const businessSegment = currentModule === 'retail-sales' ? enums.businessSegments.Retail : currentModule === 'builder-sales' ? enums.businessSegments.Builder : enums.businessSegments.Unknown;
	const currentEmployee = componentServices.securityContext.getCurrentEmployee();
	const { addresses, jobCostKeys } = builder;
	const jobInfo = {
		relayId: 0,
		itemVersion: 0,
		addresses: addresses,
		businessSegment: businessSegment,
		builderKey: contractorKey,
		coordinatorKey: currentEmployee.key,
		clientContacts: [],
		accountManagerKey: currentEmployee.key,
		estimatorKey: currentEmployee.key,
		fieldSupervisorKey: currentEmployee.key,
		isListShape: false,
		isRenovation: false,
		jobCostKeys: jobCostKeys,
		notes: [],
	};

	const result = jobModel(jobInfo);

	return result;

};


const _fillReportData = (job, summaries, shaper) => {
	shaper = shaper || defaultShaper;

	let model = store().get('model');
	const contractorsToFetch: any[] = [];
	const employeesToFetch: any[] = [];
	let prereqPromises;
	const prereqs: any[] = [];
	const jobCostResults: any[] = [];
	const variant = summaries[0].jobCost.companyVariant;
	const globalConfig = globalRelay.config!.withVariant(variant);
	const filesPromise = fileActions.fetchFilesForJob({ job });

	prereqs.push(filesPromise);

	if (job.builderKey && !model.getIn(['contractors', job.builderKey])) {
		contractorsToFetch.push(job.builderKey);
	}

	_.forEach(['accountManagerKey', 'coordinatorKey'], k => {
		const key = job[k];
		if (key && employeesToFetch.indexOf(key) === -1 && !model.getIn(['employees', key])) {
			employeesToFetch.push(key);
		}
	});

	_.forEach(contractorsToFetch, key => {
		prereqs.push(contractorActions.fetchContractor({ key: key }));
	});

	_.forEach(employeesToFetch, key => {
		prereqs.push(employeeActions.fetchEmployee({ key: key }));
	});

	_.forEach(summaries, summary => {
		prereqs.push(filesPromise.then(() => { return fillJobCostData(summary); }).then(jcResult => { jobCostResults.push(jcResult); }));
	});

	if (prereqs.length) {
		prereqPromises = Promise.all(prereqs);
	}
	else {
		prereqPromises = Promise.resolve();
	}

	return prereqPromises.then(() => {
		model = store().get('model');

		const result = job.toDocument();
		const currentEmployee = componentServices.securityContext.getCurrentEmployee();

		result.jobCosts = _.sortBy(jobCostResults, 'name');
		result.jobCostKeys = undefined;
		result.notes = undefined;
		// result.payments = undefined;
		result.statusLog = undefined;

		result.builder = model.getIn(['contractors', result.builderKey]);
		_.forEach(['accountManagerKey', 'coordinatorKey'], k => {
			result[k.replace('Key', '')] = model.getIn(['employees', result[k]]);
			result[k] = undefined;
		});

		return { currentEmployee: currentEmployee, variant: variant, companyKey: globalConfig.companyKey, companyName: globalConfig.companyName, data: shaper(result, job, summaries) };
	});
};

export const fillReportData = ({ job, summaries, shaper = undefined }) => {
	return _fillReportData(job, summaries, shaper);
};

// NOTE: Action returns are only to allow tests to access the promise. DO NOT use return values in runtime code.
export const fetchReport = ({ job, summaries, report, shaper = undefined, resolveBlob = undefined }) => {
	return _fillReportData(job, summaries, shaper)
		.then(result => {
			const reportTarget = summaries.length === 1 ? summaries[0].jobCost : job;
			
			// NOTE: filtering out external form contacts because they have a priority of 0, which creates issues at the report server when identifying the primary contact
			result.data.clientContacts = result.data.clientContacts.filter(contact => !contact.externalFormKey)

			const params = {
				url: `https://${reportHost}/api/v1/report/${report}`,
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				responseType: 'blob',
				data: JSON.stringify(result)
			};

			const promise = new Promise<Blob | void>(function fetchReport(resolve, reject) {
				serviceGateway._httpRequest(params, (err, content, extra) => {
					if (err) {
						reject(err);
					}
					else {
						const blob = new Blob([content], { type: extra.contentType });

						if (resolveBlob) {
							resolve(blob);
						}
						else {
							const url = window.URL.createObjectURL(blob);
							const a = document.createElement('a');

							a.style.display = 'none';
							a.href = url;
							a.target = '_blank';
							a.download = `${reportTarget.relayNumber} (v${reportTarget.itemVersion}) ${_.startCase(report.split('/').slice(0, 2).join(' '))}.pdf`;

							document.body.appendChild(a);

							a.click();

							resolve();

							setTimeout(function () {
								document.body.removeChild(a);
								window.URL.revokeObjectURL(url);
							}, 0);
						}
					}
				});
			});

			return promise;
		})
		.catch(err => {
			globalActions.pushAlert({ type: 'warning', message: err.message || err, isCloseable: true });
		});
};